import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getWinners, getJackpotNumber } from "../../utilities/services/jackpot";

// Async action to fetch winners
export const getWinnersData = createAsyncThunk("winners/getWinnersData", async () => {
  const response = await getWinners();
  return response.data.data; 
});

// Async action to fetch jackpot number
export const getJackpotNumberData = createAsyncThunk(
  "winners/getJackpotNumberData",
  async () => {
    const response = await getJackpotNumber();
    return response.data; 
  }
);

const winnersSlice = createSlice({
  name: "winners",
  initialState: {
    winners: [], // List of winners
    jackpotNumber:null, // Jackpot number
    loading: false, // Loading state
    error: null, // Error state
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle fetching winners
      .addCase(getWinnersData.pending, (state) => {
        state.loading = true;
      })
      .addCase(getWinnersData.fulfilled, (state, action) => {
        state.loading = false;
        state.winners = action.payload;
      })
      .addCase(getWinnersData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // Handle fetching jackpot number
      .addCase(getJackpotNumberData.pending, (state) => {
        state.loading = true;
      })
      .addCase(getJackpotNumberData.fulfilled, (state, action) => {
        state.loading = false;
        state.jackpotNumber = action.payload;
      })
      .addCase(getJackpotNumberData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default winnersSlice.reducer;
